import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import style from './DetailsSection.module.css';
import { Tab, Tabs, TabList } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { labelMap, panelMap } from './detailsUtils/tabMap';
import { Body3, WarningBody3 } from '../../../../../atomic/text/Text';
import CloseWindowButton from '../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { colors } from '../../../../../../colorVars';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';

// possible optimization- keep a local list of tabs that only updates list in activeTradePlanModule before unmount
export const DetailsSection = observer(({ tabProps, tradePlanId }) => {
  const { tabList, addTab, removeTab, selectedIndex, setSelectedIndex } =
  tabProps;
  const [optionTabWarning, setOptionTabWarning] = useState(false);
  const tabArray = Object.entries(tabList);
  const watchlistHash = `__tradePlan${tradePlanId}`;
  const { watchlistStore } = useWebsocketStore();
  const optionLength = watchlistStore.watchlists[watchlistHash]?.length;
  
  useEffect(() => {
    if (optionLength < 2) setOptionTabWarning(true);
    else setOptionTabWarning(false);
  }, [optionLength]);
  
  if(!tradePlanId) return null;
  return (
    <div className={style.container}>
      <Tabs
        className={style.outerTabs}
        selectedIndex={selectedIndex}
        onSelect={(index) => setSelectedIndex(index)}
      >
        <TabList className={style.tabsList}>
          {tabArray.map(([name]) => (
            <Tab
              className={style.tab}
              key={name}
              style={{ backgroundColor: colors.grey }}
            >
              {optionTabWarning && name === 'optionConfig' ? (
                <WarningBody3 fontWeight={700}>{labelMap[name]}</WarningBody3>
              ) : (
                <Body3 color={colors.lightGrey} fontWeight={700}>
                  {labelMap[name]}
                </Body3>
              )}
              {name !== 'tactics' &&
              name !== 'overview' &&
              name !== 'settings' &&
              name !== 'optionConfig' ? (
                <CloseWindowButton
                  width={7}
                  stroke={2}
                  color={colors.red}
                  handleClick={() => {
                    removeTab(name);
                  }}
                  display="inline"
                  margin="0 0 5px 5px"
                />
              ) : null}
            </Tab>
          ))}
        </TabList>
        {tabArray.map(([name]) => {
          const Component = panelMap[name];
          return (
            <Component key={name} tradePlanId={tradePlanId} addTab={addTab} />
          );
        })}
      </Tabs>
    </div>
  );
});

DetailsSection.propTypes = {
  tabProps: PropTypes.shape({
    tabList: PropTypes.object,
    addTab: PropTypes.func,
    removeTab: PropTypes.func,
    setLastOpenTab: PropTypes.func,
    lastOpenTab: PropTypes.number,
  }),
};

/* 
POTENTIAL MODULES
  -softOrders
  -editTactic
  -optionConfiguration
  -




*/
